export function isAdministrationPath(pathname) {
    return pathname === '/admin'
        || pathname.startsWith('/admin/')
        || /^\/project\/[^/]+\/admin(?:\/|$)/.test(pathname)
        || /^\/project\/[^/]+\/reporting-lab\/(?:tracking-quality|data-quality)(?:\/|$)/.test(pathname);
}

export function isProjectIntegrationsPath(pathname) {
    return /^\/project\/[^/]+\/settings\/integrations(?:\/|$)/.test(pathname)
        || /^\/project\/[^/]+\/system-setup(?:\/|$)/.test(pathname);
}

export function hiddenAlertIdsForPath(pathname) {
    return isProjectIntegrationsPath(pathname)
        ? ['missing-subscription', 'subscription-payment-past-due', 'subscription-retention']
        : [];
}

export function visibleProjectAlerts(pathname, alerts) {
    if (isAdministrationPath(pathname)) {
        return [];
    }

    return alerts.filter(Boolean);
}

export function visibleAlertsExcludingIds(alerts, hiddenAlertIds = []) {
    const hiddenIds = new Set(hiddenAlertIds);

    return alerts.filter((alert) => alert && !hiddenIds.has(alert.id));
}
